// src/services/assetApiService.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASEURL;

const assetApiService = {
  /**
   * Get all assets for an exchange
   * @param {number} exchangeId - The exchange ID
   * @returns {Promise<Array>} Array of asset objects
   */
  async list(exchangeId) {
    const response = await axios.get(`${API_BASE}/api/assets_exchange`, {
      params: { exchange_id: exchangeId },
      headers: { 
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  /**
   * Create a new asset
   * @param {Object} assetData - Asset data including exchange_id, symbol, amount
   * @returns {Promise<Object>} Created asset object
   */
  async create(assetData) {
    const response = await axios.post(`${API_BASE}/api/assets`, assetData, {
      headers: { 
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  /**
   * Delete an asset
   * @param {number} id - The asset ID to delete
   * @returns {Promise<void>}
   */
  async delete(id) {
    await axios.delete(`${API_BASE}/api/assets/${id}`, {
      headers: { 
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    });
  }
};

export default assetApiService;